import { Count } from 'components/controls/count';
import styles from './checkbox-with-label.module.scss';
import { type ReactNode, useRef } from 'react';
import { useEffect } from 'react';

const CheckboxWithLabel = ({
	name,
	onChange,
	id,
	count = null,
	checked,
	text,
	value,
	indeterminate = false,
	disabled = false,
	alignCheckboxToTop = false,
	toolTip,
	...restProps
}: Props) => {
	const ref = useRef<HTMLInputElement>(null);

	useEffect(() => {
		ref.current.indeterminate = indeterminate;
	}, [ref, indeterminate]);

	let labelClassString = `${styles.label} ${disabled ? styles.disabled : ''}`;

	labelClassString = toolTip
		? `${labelClassString} ${styles.hasTooltip}`
		: labelClassString;

	return (
		<div
			className={`${styles.filter} ${alignCheckboxToTop ? styles.alignCheckboxToTop : ''}`}
		>
			<input
				className={styles.input}
				name={name}
				type="checkbox"
				checked={checked}
				onChange={onChange}
				id={id}
				ref={ref}
				value={value}
				disabled={disabled}
				tabIndex={0}
				{...restProps}
			/>
			<label htmlFor={id} className={labelClassString}>
				{text || name}
				{toolTip}
				{count !== null && (
					<>
						{' '}
						<Count count={count} />
					</>
				)}
			</label>
		</div>
	);
};

export interface Props {
	alignCheckboxToTop?: boolean;
	name: string;
	onChange: any;
	id: string;
	count?: number;
	text?: string;
	checked?: boolean;
	value?: any;
	indeterminate?: boolean;
	disabled?: boolean;
	toolTip?: ReactNode;
}

export default CheckboxWithLabel;
